import React, { useState } from 'react'
import { useLoaderData } from 'react-router-dom'
import { t } from '@lingui/core/macro'
import { ApplePayPageData } from '../../loaders/applePayPageLoader'
import { useApplePaySession } from '../../hooks/useApplePaySession'
import { availableApplePay } from '../../utils/apple'
import MainButton from '../../components/MainButton/MainButton'
import QrApplePay from '../../components/QrApplePay/QrApplePay'
import Expired from '../../components/Expired/Expired'
import PaymentError from '../../components/PaymentError/PaymentError'
import OrderInfo from '../../components/OrderInfo/OrderInfo'
import Spinner from '../../components/Spinner/Spinner'
import TimeLeft from '../../components/TimeLeft/TimeLeft'
import styles from './ApplePayPage.module.css'

const ApplePayPage = () => {
    const { paymentPageInfo, transaction } = useLoaderData<ApplePayPageData>()
    const { startApplePay, error, isProcessing } = useApplePaySession(paymentPageInfo.id)

    const [isExpired, setIsExpired] = useState(paymentPageInfo.expiresAt && new Date(paymentPageInfo.expiresAt) < new Date())

    const handleApplePayment = () => {
        startApplePay(transaction)
    }

    if (isExpired) {
        return (
            <Expired
                orderId={paymentPageInfo.orderId}
                redirectUrl={paymentPageInfo.redirectUrl}
                redirectTimeout={paymentPageInfo.redirectTimeout}
            />
        )
    }

    if (error) {
        return (
            <PaymentError
                paymentPageInfo={paymentPageInfo}
                removePaymentError={() => {}}
            />
        )
    }

    if (!availableApplePay) {
        return (
            <>
                <TimeLeft
                    expiresAt={paymentPageInfo.expiresAt}
                    onExpired={() => setIsExpired(true)}
                />
                <QrApplePay />
            </>
        )
    }

    return (
        <>
            <TimeLeft
                expiresAt={paymentPageInfo.expiresAt}
                onExpired={() => setIsExpired(true)}
            />
            <div className={styles.section}>
                <h2 className={styles.title}>{t`Оплата через Apple Pay`}</h2>

                <p className={styles.text}>{t`Быстрая и безопасная оплата с помощью Face ID, Touch ID или пароля`}</p>

                <OrderInfo transaction={transaction} orderId={paymentPageInfo.orderId} description={paymentPageInfo.description} />

                <div className={styles.paymentSection}>
                    {isProcessing ? (
                        <div className={styles.processingState}>
                            <Spinner />
                            <p className={styles.processingText}>
                                {t`Пожалуйста, завершите оплату в диалоге Apple Pay`}
                            </p>
                        </div>
                    ) : (
                        <MainButton
                            message={t`Оплатить`}
                            type="button"
                            onClick={handleApplePayment}
                            disabled={false}
                        />
                    )}
                </div>
            </div>
        </>
    )
}

export default ApplePayPage
